class VoucherSearchController extends BaseSearchController
	@register()
	@inject 'VoucherRepository',
		'BACKEND_GIFTCARD_ENTITY_TYPE'

	search: (isManualSubmit = false, appendResult = true) ->
		if (!@searchData.isSearching && @searchData.hasMoreItems) || isManualSubmit
			@searchData.isSearching = true
			@showAdvancedSearch = false

			query = @getQuery(isManualSubmit)
			query.criteria 'entity_type', '!=', @BACKEND_GIFTCARD_ENTITY_TYPE.RETAIN24

			return @VoucherRepository
				.findVouchersList query
				.then (response) =>
					@afterSearch response.data, isManualSubmit, appendResult
				.catch (response) =>
					@searchData.isSearching = false

					return Promise.reject(response)
		else
			return @$q.when(false)

	getGiftcardReferenceId: (giftcard) ->
		return giftcard.id.substring(0, Math.min(6, giftcard.id.indexOf('-')))
